import { Select, TextField } from "@material-ui/core";
import { MutationFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Field, FieldArray, Form, Formik, FormikValues } from "formik";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { CustomErrorMessage } from "../../../../components/FormComponents/CustomErrorMessage";
import { genericFileUpload, genericGet, genericPatch, genericPost, genericUpdate } from "../../../../services/api.service";
import { IClient, IMachine, IObra, ObraState, IPeca } from "../IObra";
import PublishIcon from '@mui/icons-material/Publish';
import CloseIcon from '@mui/icons-material/Close';
import { hasError } from "../../../../components/FormComponents/utils";
import { useEffect, useRef, useState } from "react";
import { FormFieldWrapper } from "../../../../components/FormComponents/FieldWrapper";
import { Autocomplete, Chip, MenuItem } from "@mui/material";
import { PecasForm } from "./PecasForm";
import { AxiosResponse } from "axios";
import { Box } from "@mui/system";
import { IOrcamento } from "../../../Orcamentos/newOrcamentos/IOrcamento";
import { FormFieldWrapperColumn } from "../../../../components/FormComponents/FieldWrapperColumn/FieldWrapperColumn";



export function ObraForm({ obra, onCancel }: { obra?: IObra, onCancel?: Function }) {

    const location = useLocation();
    const navigate = useNavigate();
    const [selectedClient, setSelectedClient] = useState<any>(obra?.client);
    const pecasFormRef = useRef(null);
    const formRef = useRef<any>(null);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const locallySavedObra = localStorage.getItem('obraForm')? JSON.parse(localStorage.getItem('obraForm') || "") : null;


    const isEditingExisting = obra?.id || locallySavedObra?.id;
    const successMessage = isEditingExisting ? 'Obra atualizada com sucesso' : 'Obra criada com sucesso';
    const errorMessage = isEditingExisting ? 'Erro ao atualizar obra' : 'Erro ao criar obra';


    const [pecasAmount, setPecasAmount] = useState<number>(obra?.pecas?.length ?? 0);

    const saveCurrentState = (value: any) => {
        localStorage.setItem('obraForm', JSON.stringify(value));
        toast.success("Formulário guardado localmente!");
    }

    let boundArrayHelpers: any;

    const bindArrayHelpers = (arrayHelpers: any) => {
        boundArrayHelpers = arrayHelpers;
    }

    const updatePecasFromOrcamento = (newValue: any) => {

        console.log("New vakuue: ", newValue);

        const currentPecasLength: number = formRef.current.values.pecas.length;

        for (let i = 0; i < currentPecasLength; i++) {
            boundArrayHelpers.pop();
        }

        const orcamentos = newValue as any;
        let amount = 0;
        (orcamentos as IOrcamento[])?.flatMap((o: IOrcamento) => {
            return o.pecasOrcamentadas?.map((p: IPeca) => {
                amount += 1;
                boundArrayHelpers.push({
                    reference: p.reference,
                    material: p.material,
                    amount: p.amount,
                    desenhosTecnicos: p.desenhosTecnicos ?? [],
                })
            });
        })

        setPecasAmount(amount);
    }


    const formInitialValues: Partial<IObra> = locallySavedObra || {
        id: obra?.id,
        number: obra?.number,
        client: obra?.client,
        value: obra?.value,
        orderNote: obra?.orderNote,
        partAmount: obra?.partAmount,
        overallDuration: obra?.overallDuration,
        overallDurationInDays: obra?.overallDurationInDays,
        state: obra?.state ?? ObraState.TO_START,
        orcamentos: obra?.orcamentos ?? [],
        machines: obra?.machines ?? [],
        entregas: obra?.entregas,
        bills: obra?.bills ?? [],
        pecas: obra?.pecas ?? []
    }

    const { data: clients = [] } = useQuery<IClient[]>({
        queryKey: ['clients'],
        queryFn: async () => {
            return await genericGet('/findByFilter/clientes');
        }
    })
    const { data: machines = [] } = useQuery<IMachine[]>({
        queryKey: ['machines'],
        queryFn: async () => {
            return await genericGet('/findByFilter/maquinas');
        }
    })

    const { data: orcamentos = [] } = useQuery<IOrcamento[]>({
        queryKey: ['orcamentos', selectedClient],
        queryFn: async () => {
            if (selectedClient?.id) return await genericGet(`/orcamentos/client/${selectedClient?.id}`);
            return [];
        }
    })

    const { data: materiais = [] } = useQuery({
        queryKey: ['materiais'],
        queryFn: async () => {
            return (await genericGet('/materiais?page=1&take=100000')).data;
        }
    })

    const mutationMethod = (): MutationFunction<AxiosResponse<any, any>, any> => {
        if (!isEditingExisting) return genericPost('/obras');
        return genericPatch(`/obras/${isEditingExisting}`);
    };


    const mutation = useMutation(mutationMethod(), {
        onSuccess: async (response) => {
            toast.success(successMessage);
            localStorage.removeItem('obraForm');
            
            const updatedPecas = response.data.pecas;
            updatedPecas.forEach((p: IPeca) => {
                const matchingFormPeca = formRef?.current?.values.pecas.find((p2: IPeca) => p2.reference === p.reference);
                const matchingResponsePeca = response.data.pecas.find((p2: IPeca) => p2.reference === p.reference);
                p.desenhosTecnicos = matchingFormPeca?.desenhosTecnicos ?? [];
                p.id = matchingResponsePeca?.id ?? null;
            })

            console.log("Updated pecas: ", updatedPecas);

            await Promise.all(updatedPecas.map(async (p: IPeca) => {
                const documentToSave = new FormData();
                p.desenhosTecnicos.map((dt: File) => {
                    documentToSave.append('desenhos-tecnicos', dt);
                })
                await genericFileUpload('/pecas/' + p.id + '/desenhos-tecnicos/upload')(documentToSave);
            }))

            toast.success("Desenhos técnicos enviados com sucesso");
            setSubmitDisabled(false);
            onCancel ? onCancel() : navigate(-1);
        },
        onError: () => {
            toast.error(errorMessage)
            setSubmitDisabled(false);
        }
    })




    useEffect(() => {
        formRef?.current?.setFieldValue('partAmount', pecasAmount);
    }, [pecasAmount])



    return (<div className="border rounded-md shadow-md p-8 px-16 text-sm m-10">
        <Formik
            initialValues={formInitialValues}
            // mutation.mutate(({ ...values }))
            validateOnChange={false}
            onSubmit={async (values: FormikValues) => {
                setSubmitDisabled(true);
                mutation.mutate(values);
            }}
            innerRef={formRef}
        >

            {(props) => {
                const { values, errors, touched, handleChange, setFieldValue } = props;
                return (
                    <Form >
                        <div className="flex">
                            <FormFieldWrapperColumn label={"Cliente"} className={"w-1/2"}>
                                <Field
                                    className="w-full"
                                    name="client"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
                                        // handleChange(e);
                                        setFieldValue('client', newValue);

                                        setSelectedClient(newValue);
                                        setFieldValue('orcamentos', []);
                                    }}
                                    value={values.client}
                                    as={Autocomplete}
                                    variant={'outlined'}
                                    label={'Cliente'}
                                    options={clients}
                                    // renderValue={(item: IClient) => item.name}
                                    getOptionLabel={(client: IClient) => client.name || ""}

                                    renderInput={(params: any) => (
                                        <TextField
                                            {...params}
                                            label={'Cliente'}
                                            placeholder={'Cliente'}
                                        />
                                    )}

                                />
                                {/* {clients.map((c: IClient) => <MenuItem key={c.id} value={c as any}>{c.name}</MenuItem>)} */}
                                {/* </Field> */}
                            </FormFieldWrapperColumn>

                            <FormFieldWrapperColumn label={"Número da Obra"} className={"w-1/2"}>
                                <>
                                    <Field
                                        className="w-full"
                                        name="number"
                                        as={TextField}
                                        error={hasError({ errors, touched, name: 'number' })}
                                        variant={'outlined'}
                                        type={'text'}
                                        label={'Número da obra'} />
                                    <CustomErrorMessage name={"number"} />
                                </>
                            </FormFieldWrapperColumn>
                        </div>

                        <div className="flex">
                            <FormFieldWrapperColumn label={"Orçamentos"} className={"w-1/2"}>
                                <Field
                                    className="w-full"
                                    name="orcamentos"
                                    value={values.orcamentos}
                                    disabled={!values.client}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
                                        // handleChange(e);
                                        setFieldValue('orcamentos', newValue);
                                        updatePecasFromOrcamento(newValue);
                                        const orcamentos = (newValue as any) as IOrcamento[];
                                        if (orcamentos.length) {
                                            const newVal: number = orcamentos.reduce((prev: number, o: IOrcamento) => prev + (o.valueWithIVA ? o.valueWithIVA : 0), 0);
                                            setFieldValue('value', newVal);
                                            touched.value = true;
                                        } else {
                                            setFieldValue('value', 0);
                                        }
                                    }}
                                    as={Autocomplete}
                                    multiple
                                    filterSelectedOptions
                                    options={orcamentos}
                                    variant={'outlined'}
                                    autoHighlight
                                    label={'Orçamentos'}
                                    getOptionLabel={(option: IOrcamento) => option.billCode || ""}
                                    renderInput={(params: any) => (
                                        <TextField
                                            {...params}
                                            label={'Orçamentos'}
                                            placeholder={'Orçamentos'}
                                        />
                                    )}
                                />
                                {/* {orcamentos.map((b: IOrcamento) => <MenuItem key={b.id} value={b as any}>{b.billCode}</MenuItem>)}
                                </Field> */}
                            </FormFieldWrapperColumn>

                            <FormFieldWrapperColumn label={"Valor da Obra"} className={"w-1/2"}>
                                <>
                                    <Field
                                        className="w-full"
                                        name="value"
                                        as={TextField}
                                        type={"number"}
                                        error={hasError({ errors, touched, name: 'value' })}
                                        variant={'outlined'}
                                        label={'Valor da obra'} />
                                    <CustomErrorMessage name={"value"} />
                                </>
                            </FormFieldWrapperColumn>
                        </div>
                        <div className="flex">
                            <FormFieldWrapperColumn label={"Nota de encomenda"} className={"w-1/2"}>
                                <>
                                    <Field
                                        className="w-full"
                                        name="orderNote"
                                        as={TextField}
                                        type={"text"}
                                        error={hasError({ errors, touched, name: 'orderNote' })}
                                        variant={'outlined'}
                                        label={'Nota de encomenda'} />
                                    <CustomErrorMessage name={"orderNote"} />
                                </>
                            </FormFieldWrapperColumn>

                            <FormFieldWrapperColumn label={"Máquinas"} className={"w-1/2"}>
                                <Field
                                    className="w-full"
                                    name="machines"
                                    value={values.machines}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>, newValue: IMachine[]) => {
                                        // handleChange(e);
                                        setFieldValue('machines', newValue);
                                        const value: number = values.value || 0;
                                        const machinesProd: number = (newValue)?.reduce((p: any, c: any) => p + c['production'], 0)
                                        const totalProduction = (value / machinesProd) * 8;
                                        setFieldValue('overallDuration', totalProduction);
                                    }}
                                    as={Autocomplete}
                                    multiple
                                    filterSelectedOptions
                                    options={machines}
                                    variant={'outlined'}
                                    autoHighlight
                                    label={'Máquinas'}
                                    getOptionLabel={(option: IMachine) => option.ref || ""}
                                    renderInput={(params: any) => (
                                        <TextField
                                            {...params}
                                            label={'Máquinas'}
                                            placeholder={'Máquinas'}
                                        />
                                    )}
                                />
                                {/* {machines.map((b: IMachine) => <MenuItem key={b.id} value={b as any}>{b.ref}</MenuItem>)}
                                </Field> */}
                            </FormFieldWrapperColumn>


                        </div>

                        <div className="flex">


                            <FormFieldWrapperColumn label={"Duração total (h)"} className={"w-1/2"}>
                                <>
                                    <Field
                                        className="w-full"
                                        name="overallDuration"
                                        as={TextField}
                                        type={"number"}
                                        error={hasError({ errors, touched, name: 'overallDuration' })}
                                        variant={'outlined'}
                                        label={'Duração total (h)'} />
                                    <CustomErrorMessage name={"overallDuration"} />
                                </>
                            </FormFieldWrapperColumn>

                            <FormFieldWrapperColumn label={"Estado"} className={"w-1/2"}>
                                <Field
                                    className="w-full"
                                    name="state"
                                    value={values.state}
                                    as={Select}
                                    variant={'outlined'}
                                    label={'Estado'}
                                >
                                    {Object.values(ObraState).map((s: string) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                                </Field>
                            </FormFieldWrapperColumn>
                        </div>


                        <div ref={pecasFormRef}>
                            <FieldArray
                                name={"pecas"}

                                render={arrayHelpers => {
                                    bindArrayHelpers(arrayHelpers);
                                    return (
                                        <PecasForm saveCurrentState={saveCurrentState} formikProps={props} pecasArrayHelpers={arrayHelpers} setPecasAmount={setPecasAmount} materiais={materiais} />
                                    )
                                }}
                            />
                        </div>

                        <FormFieldWrapper label={"Quantidade de peças"} hideRule className="mt-3">
                            <>
                                <Field
                                    className="w-full"
                                    name="partAmount"
                                    as={TextField}
                                    type={"number"}
                                    error={hasError({ errors, touched, name: 'partAmount' })}
                                    variant={'outlined'}
                                    label={'Quantidade de peças'} />
                                <CustomErrorMessage name={"partAmount"} />
                            </>
                        </FormFieldWrapper>

                        <div className="flex justify-between mt-3">
                            <CustomButtonSimple className="mr-2 bg-cyan-600" text={"Guardar"} Icon={<CloseIcon />} onClick={() => saveCurrentState(values)} />

                            <div className="flex justify-end mr-2">
                                <CustomButtonSimple className="mr-2" text={"Cancelar"} Icon={<CloseIcon />} onClick={() =>{
                                     localStorage.removeItem('obraForm');
                                     onCancel ? onCancel(false) : navigate(-1)
                                     }} />

                                <CustomButtonSimple disabled={submitDisabled} type="submit" text={"Submeter"} Icon={<PublishIcon />} />
                            </div>

                        </div>

                    </Form>

                )

            }}

        </Formik>

    </div>)


}